import React, { useState, useEffect } from 'react';
import Tab from "../components/tab";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import Footer from "../components/Footer";
import { useSelector, useDispatch } from "react-redux";
import {
  dispatchSkills,
  returnHome,
} from "../../../Redux/ActionCreator";
import { convertSkills } from "../../../Redux/convertResume";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { saveIntoServerCache, getTwoFromServerCache, getOneFromServerCache } from "../../../utils/saveIntoCache";
import { capitalize } from '../../../utils/capitalize/capitalizeWord';

const Skill3 = ({nextStep, prevStep}) => {

  const dispatch = useDispatch();
  
  const Tech_skills = useSelector((e) => e.skills);
  const sidebar = useSelector(e => e.sidebarOpen.message);
  const Personal_skills = useSelector((e) => e.p_skills);
  const combined_skills = useSelector(e => e.combine_skills);
  const flowLanguage = useSelector(e => e.t_lang.selected);
  const [ monitorAddedSkill, setMonitorAddedSkills ] = useState(false);
  const [skills, setSkills]  = useState(combined_skills?.skills || []);

  const [skillInput, setSkillInput] = useState('');

  const addSkill = () => {
    if (skills.length < 15) {
      if (skillInput.trim() !== '') {
        setMonitorAddedSkills(true);
        setSkills([...new Set([...skills, capitalize(skillInput)])]);
        setSkillInput('');
      }
    } else {
      setTimeout(() => {
        toast.error("You have reach maximum skills you can select", {
            position: toast.POSITION.TOP_RIGHT,
        });
      }, 50);
    }
  };

  const removeSkill = (index) => {
    const updatedSkills = skills.filter((_, i) => i !== index);
    setSkills(updatedSkills);
  };

  useEffect(() => {
    // dispatch(combine_skills(skills))
    // save into server cache
    
    dispatch(dispatchSkills(skills));
    let saveToCache = async () => {
      await saveIntoServerCache("technicalSkills", skills);
    }
    saveToCache();
  }, [skills])

  useEffect(() => {

    if (Tech_skills?.skills !== null /* && Personal_skills?.p_skills !== null */) {
      setSkills([ ...Tech_skills?.skills/* , ...Personal_skills?.p_skills */ ]);
    } else {
      // console.log("skillsss", props.skills)
      let cacheInfo = getTwoFromServerCache("technicalSkills", "personalSkills")
      cacheInfo.then(res => res.json())
        .then(res => {
          // console.log("server cache value", res);
          if (res.success == true) {
            if (res.data?.value1 !== null && res.data?.value1 !== undefined) {
              let resObj = JSON.parse(res.data.value1);
              // console.log("value 1", resObj);
              dispatch(dispatchSkills([... new Set(resObj)]));
              setSkills(prev => [ ...prev, ...resObj]);
            }
            /* if (res.data?.value2 !== null && res.data?.value2 !== undefined) {
              let resObj = JSON.parse(res.data.value2);
              // console.log("value 2", resObj);
              dispatch(dispatchPskills([... new Set(resObj)]));
              setSkills(prev => [ ...prev, ...resObj]);
            } */
            // dispatch(saveSkills(res.data.value1, res.data.value2, secret.secret));
            // console.log("Done");
          } else if (res.success === false && res.message == "Unauthorized") {
            dispatch(returnHome(res.status));
          }
        })
    }
  }, []);
  console.log("skills", skills);

      /* Moving section */
      const handlePrev = () => {
          prevStep();
      }

    const handleNextCall = async () => {
      // handleNext(dispatch, firstName, lastName, nextStep);
      try {
            //translate the skills part here
            if (monitorAddedSkill) {              
              dispatch(convertSkills({Technical_skills: Tech_skills?.skills, Personal_skills: Personal_skills?.p_skills, Lang: [{lang: flowLanguage }] }, "resume"));
            }
            // dispatch(combine_skills_loading());
            nextStep();
      } catch (error) {
          throw error
      }
    }

  return (
    <div className="bg-[#FAFAFA] px-4 md:px-6 lg:px-8 xl:px-10 py-8 w-full overflow-y-scroll ScrollOnly min-h-calc-70 flex justify-center lg:items-center">
      <div className={`${sidebar ? "sm:max-w-[65vw]" : "sm:max-w-[80vw]"} vsm:w-[90vw] gap-y-10 h-max py-10 px-6 md:px-8 md:py-8 lg:gap-0 lg:h-full bg-white flex flex-col lg:justify-between rounded-lg shadow-md`}>
        <div className="flex justify-between items-center mb-4">
          <div className="tabarea gap-x-4 items-center inline-flex flex-shrink-0 max-w-full overflow-hidden">
            <div className="vsm:hidden md:inline">
              <Tab
                label="Personal Information"
                current={false}
                completed={true}
                num="1"
              />
            </div>
            <div className="vsm:hidden md:inline">
              <Tab num="2" current={false} label="Experience" completed={true} />
            </div>
            <Tab num="3" current={true} label="Skills" completed={false} />
            <Tab num="4" current={false} label="Education" completed={false} />
            <Tab num="5" current={false} label="Professional Summary" completed={false} />
          </div>
        </div>


        <div className="flex justify-center w-full">
          <div className='flex flex-col gap-y-6 items-center w-full lg:max-w-[90%] justify-center'>
            <h2 className="text-xl font-semibold mb-2 notranslate">
              {flowLanguage == "Spanish" ? (
                <Typewriter key={flowLanguage} words={["Muy bien, ¿qué habilidad te gustaría agregar?"]} loop={1} typeSpeed={40} />
              ) : (
                <Typewriter key={flowLanguage} words={["Alright, what skill would you like to add?"]} loop={1} typeSpeed={40} />
              )}
              {/* <Typewriter words={["Alright, what skill would you like to add?"]} loop={1} typeSpeed={50} /> */}
            </h2>
            <motion.div 
              initial={{ opacity: 0, y: 30 }} 
              animate={{ opacity: 1, y: 0 }} 
              transition={{ duration: 0.8, ease: "easeOut", delay: 1.8 }} 
              className="md:flex items-center justify-center vsm:flex-wrap w-full"
            >
              <input
                type="text"
                placeholder="Type your skill here"
                className="w-full max-w-[400px] border-2 border-orange-500 rounded-md py-2 px-3 placeholder:text-[#000000AB] focus:outline-none focus:ring-2 focus:ring-[#FF6633] focus:border-transparent mr-2"
                value={skillInput}
                onChange={(e) => setSkillInput(e.target.value)}
              />
              <button
                className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-4 rounded-lg vsm:my-4 my-0 vsm:w-full md:w-auto border-2 max-w-[400px] notranslate"
                onClick={addSkill} key={flowLanguage}
              >
                {flowLanguage == "Spanish" ? (
                  "+ Agregar habilidad"
                ) : (
                  "+ Add skill"
                )}
                
              </button>
            </motion.div>
          </div>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 30 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.8, ease: "easeOut", delay: 3.5 }} 
          className=" flex justify-center mb-8"
        >
          <div>
            <h3 className="text-lg text-center font-semibold mb-2 notranslate" key={flowLanguage}>
            {flowLanguage == "Spanish" ? (
              "Has agregado:"
            ) : (
              "You have added:"
            )}
              
            </h3>
            <div className="flex flex-wrap justify-center gap-2">
              {skills?.map((skill, index) => (
                <div key={index} className="bg-gray-200 rounded-xl px-4 py-3 flex items-center">
                  <span className="mr-2">{skill}</span>
                  <button onClick={() => removeSkill(index)} className='text-gray-600'><span>&times;</span></button>

                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Navigation Buttons */}


        {/* Navigation Buttons */}
        <div className="flex justify-center w-full">
          <motion.div 
            initial={{ opacity: 0, y: 30 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="flex justify-between lg:max-w-[90%] w-full">
              <button
                onClick={handlePrev}
                className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4 vsm:px-6 px-8 rounded-md"
              >
                  <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                      "ANTERIOR"
                    ) : (
                      "PREVIOUS"
                    )}
                  </span>
              </button>
              
              <button
                  onClick={handleNextCall}
                  className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4 px-6 rounded-md"
              >
                <span className="notranslate" key={flowLanguage}>
                  {flowLanguage == "Spanish" ? (
                    "GUARDAR"
                  ) : (
                    "SAVE"
                  )}
                </span>
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>

            </motion.div>
          </div>

      </div>
      <ToastContainer />
    </div>
  );
};

export default Skill3;
